// ©2024 Austin App House. All rights reserved.
import React from 'react';

const ContractorPreferedGroupsChecks = () => {
  return (
    <div className='prefered-icon' title='Preferred groups'>P</div>
  )
};

export default ContractorPreferedGroupsChecks;
